export default __webpack_public_path__ + "static/img-evernew-capital-53bf67e118ba6276e9ad9ad95a1d7483.png";